import { useEffect, useState } from 'react'
import { Link } from '../typo/link'
import { Category } from './category'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { JeffMendez } from '../svgs/jeff'
import { classNames } from '@app/utils/classes'
import { getDateLocale } from '@app/utils/date-locale'

interface CardProps {
  backgroundImage?: string
  category: string
  cardTitle: string
  cardDescription: string
  authorName?: string
  href: string
  date: Date
  translation?: string
  sm?: boolean // small card
}

// card used to display content
export const Card = ({
  href,
  category,
  cardTitle,
  cardDescription,
  date,
  authorName,
  backgroundImage,
  translation,
  sm,
}: CardProps) => {
  const { t, lang } = useTranslation(translation ?? 'blog')
  const [timeStamp, setTime] = useState<string>(date && date.toISOString())

  useEffect(() => {
    if (date) {
      setTime(
        getDateLocale(date, lang, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      )
    }
  }, [lang, date, setTime])

  const textDescription = t(cardDescription)
  const textTitle = t(cardTitle)

  const jumboID = `card-${href.replaceAll('/', '-')}`

  return (
    <Link
      href={href}
      className='relative overflow-hidden bg-gray-100 dark:bg-gray-900 rounded border dark:border-gray-800 hover:no-underline hover:transform hover:-translate-y-1'
      aria-labelledby={jumboID}
    >
      <article>
        <div className='relative overflow-hidden'>
          <div
            className={classNames(
              'w-full bg-[#d6d6d6] bg-cover',
              sm ? 'min-h-[3.25rem]' : 'min-h-[8.75rem]',
              backgroundImage ?? ''
            )}
          ></div>
          <Category category={category} translation={translation} />
        </div>
        <div className='overflow-hidden relative px-2 py-2 space-y-1 h-[100px]'>
          <h3
            className={classNames(
              'font-semibold text-gray-800 dark:text-gray-100 leading-snug'
            )}
            id={jumboID}
          >
            {textTitle}
          </h3>
          <div
            className={`text-sm text-gray-700 dark:text-gray-200 ${
              textDescription.length + textTitle.length > 140
                ? 'line-clamp-2'
                : 'line-clamp-3'
            }`}
          >
            {textDescription}
          </div>
        </div>
        {authorName ? (
          <div className='py-2 px-2 space-x-2 flex text-gray-800 dark:text-gray-800 place-items-center'>
            <JeffMendez
              className='w-5 rounded-full relative fill-black dark:fill-gray-400 border dark:border-gray-700'
              width={24}
              height={24}
            />
            <div className='flex flex-1 place-items-center place-content-between text-sm'>
              <div className='text-gray-700 dark:text-gray-200'>
                {authorName}
              </div>
              <div className='text-sm text-black dark:text-gray-200'>
                {timeStamp}
              </div>
            </div>
          </div>
        ) : null}
      </article>
    </Link>
  )
}
